export default {
	Wishlisting: 'Wishlisting',
	Profile: 'Profile',
};
